var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "send-container" },
    [
      _vm.draftSendTime && !_vm.draftSent
        ? _c(
            "div",
            { staticClass: "send-loader", attrs: { title: "Sending..." } },
            [_c("straight-line-loader")],
            1
          )
        : _c(
            "md-button",
            {
              class: [
                "md-just-icon md-round md-primary",
                {
                  "md-warning": _vm.newDraftCostAdded,
                  "md-success": _vm.draftSendTime && _vm.draftSent,
                  "bulk-send-draft-btn": _vm.isBulk,
                },
              ],
              attrs: { title: _vm.iconTitle },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleSendDraftApproval()
                },
              },
            },
            [
              _vm.emailToolTip
                ? _c("md-tooltip", { attrs: { "md-direction": "left" } }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.emailToolTip) + "\n        "
                    ),
                  ])
                : _vm._e(),
              _c("md-icon", [_vm._v(_vm._s(_vm.buttonIcon))]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }